module.exports = __webpack_public_path__ + "static/media/Group 27.43c0312f.svg";